export default __webpack_public_path__ + "static/media/03AW3JUL66.0b2a8a7f.jpg";